import CircleTick from './CircleTick';

export default CircleTick;
